import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useLocaisOutletContext } from 'pages/Locais.context'
import { useParams } from 'react-router-dom'
import { FuncionariosAssociadosLocal } from '../atoms/FuncionariosAssociados'

export default function AssociarLocal() {
    const { id } = useParams()
    const { data } = useLocaisOutletContext()
    const localSelecionado = data?.find(item => item.id === Number(id))

    if (!localSelecionado) return null

    return (
        <Dialog.Root open={hasPermission(['read', 'Funcionários'])}>
            <Dialog.Title action="Funcionários do local">
                {localSelecionado.nomeLocal}
            </Dialog.Title>
            <Dialog.Content>
                <FuncionariosAssociadosLocal localId={localSelecionado.id} />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Fechar
                </Dialog.Actions.SecondaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
